import { PostStructuredData_post$data } from './__generated__/PostStructuredData_post.graphql'
import { replacementImageForPost } from '@lifedot/constants/images'
import { useMemo } from 'react'
import { router, urlify } from '@lifedot/router'

export const useArticle = (
  post: PostStructuredData_post$data | null,
  show: boolean
): string | undefined => {
  return useMemo(
    () =>
      show
        ? JSON.stringify({
            '@context': 'http://schema.org',
            '@type': 'Article',
            description: post?.meta_description ?? '',
            datePublished: post?.published_at ?? '',
            headline: post?.h1 ?? '',
            image: post?.image?.url ?? replacementImageForPost.path,
            dateModified: post?.modified_at ?? '',
            publisher: {
              '@type': 'Organization',
              name: 'ライフドット',
              logo: {
                '@type': 'ImageObject',
                url: 'https://res.www.a-tm.co.jp/wp-content/uploads/2020/07/20165557/20200721_Life._01.png'
              }
            },
            author: {
              '@type': 'Person',
              name: 'ライフドット編集部',
              description:
                'ライフエンディングにまつわる不安や悩みの解消を目指し、情報の発信しています。内容が難しくなりがちなエンディング業界の情報を、「読者に寄り添ってわかりやすく発信する」を心がけて提供しております。'
            },
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': urlify(router.post(post?.slug ?? ''))
            }
          })
        : undefined,
    [
      post?.h1,
      post?.image?.url,
      post?.meta_description,
      post?.modified_at,
      post?.published_at,
      post?.slug,
      show
    ]
  )
}
